import { IExtension } from "redux-dynamic-modules-core";
import { AnyAction, combineReducers, ReducersMapObject } from "redux";

import {
  GetStoreParams,
  ModuleTuple,
  WindowWithStore
} from "../types/contracts";
import createStore from "../store";
import { STOREKEY, HYDRATE } from "../constants";
import getSagaExtension from "./sagaExtention";
import {
  ModuleStoreWithSagaTasks,
  SagaContext
} from "./sagaExtention/contracts";

declare const window: WindowWithStore;

interface StoreCreatorConfig {
  modules: ModuleTuple;
  sagaContext?: SagaContext;
  extensions?: IExtension[];
}

const combineReducersWithGlobalActions = (reducersMap: ReducersMapObject) => {
  const reducersMapWithHydration = Object.keys(reducersMap).reduce(
    (acc, reducerKey) => {
      acc[reducerKey] = (state: any, action: AnyAction) => {
        let nextState = state;

        if (action.type === HYDRATE && action.payload[reducerKey]) {
          Object.entries(action.payload[reducerKey]).forEach(([key, value]) => {
            nextState = {
              ...nextState,
              [key]: value
            };
          });
        }

        return reducersMap[reducerKey](nextState, action);
      };

      return acc;
    },
    {} as ReducersMapObject
  );

  return combineReducers(reducersMapWithHydration);
};

const createStoreWithSagaTasks = ({
  modules,
  sagaContext,
  extensions = []
}: StoreCreatorConfig) => {
  const sagaExtension = getSagaExtension(sagaContext);

  const store = createStore(
    {
      extensions: [sagaExtension, ...extensions],
      advancedCombineReducers: combineReducersWithGlobalActions
    },
    modules
  ) as ModuleStoreWithSagaTasks;

  store.sagaTasks = sagaExtension.sagaTasks;

  return store;
};

export default function getStore({
  rootModules = [],
  pageModules = []
}: GetStoreParams): ModuleStoreWithSagaTasks {
  if (typeof window === "undefined") {
    return createStoreWithSagaTasks({
      modules: rootModules.concat(pageModules)
    });
  }

  // Memoize store if client
  if (!(STOREKEY in window)) {
    window[STOREKEY] = createStoreWithSagaTasks({
      modules: rootModules.concat(pageModules)
    });
  }

  return window[STOREKEY];
}
